import { validateEmail, validatePassword } from '@perch-labs/warbler';
import { copyFor } from 'config';

const getClientError = copyFor('errors.client');

interface Variables {
  email?: string;
  password?: string;
  emailError?: string;
  passwordError?: string;
}

interface Params {
  setVariables: (variables: Variables) => void;
  variables: Variables;
}

export const validateForm = ({ setVariables, variables }: Params) => {
  const { email, password } = variables;
  const variablesUpdate: Variables = {};
  if (!validateEmail(email || ''))
    variablesUpdate.emailError = getClientError('invalidEmail');
  if (password && !validatePassword(password))
    variablesUpdate.passwordError = getClientError('invalidPassword');
  if (Object.keys(variablesUpdate).length) {
    setVariables({ ...variables, ...variablesUpdate });
    return false;
  }
  return true;
};
